import { getCookie } from '@/utils/cookies';
import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

interface Translations {
  [namespace: string]: { [key: string]: string };
}

interface Resources {
  [lang: string]: Translations;
}

const fallbackLng = 'en';
const savedLang = getCookie('i18nLanguage') || fallbackLng;
export const supportedLngs = ['en', 'fr', 'de', 'nl'];

const modules = import.meta.glob<{ default: { [key: string]: string } }>(
  '/src/translations/*/*.json',
  { eager: true },
);
const resources: Resources = {};

for (const path in modules) {
  const match = path.match(/\/translations\/([a-zA-Z-]+)\/([a-zA-Z-]+)\.json$/);
  if (match) {
    const lang = match[1];
    const namespace = match[2];
    const translations = modules[path].default || modules[path];

    if (!resources[lang]) {
      resources[lang] = {};
    }
    resources[lang][namespace] = translations;
  }
}

i18n.use(initReactI18next).init({
  lng: savedLang,
  fallbackLng,
  supportedLngs,
  resources,
  interpolation: {
    escapeValue: false,
  },
  react: {
    useSuspense: true,
  },
});

export default i18n;
